const dict = {
  uk: {
    adminAuth: {
      title: 'Вхід для адміністратора',
      notAdminAccount: 'Цей акаунт не є акаунтом адміністратора',
      loginError: 'Помилка входу',
      connectionError: "Помилка з'єднання. Спробуйте пізніше.",
      passwordLabel: 'Пароль',
      passwordPlaceholder: 'Введіть пароль',
      loggingIn: 'Вхід...',
      loginBtn: 'Увійти',
    },
    googleAuth: {
      cannotConnect: "Не вдалося з'єднатися з сервером. Спробуйте пізніше.",
      serverUnavailable: 'Сервер недоступний ({{status}}). Спробуйте пізніше.',
      googleError: 'Помилка авторизації через Google',
      googleConnectError: 'Помилка підключення до Google',
      loading: 'Завантаження...',
      loginWithGoogle: 'Вхід через акаунт Google',
    },
    referralBonus: {
      bonusIntro: 'Отримайте {{amount}} грн бонусу за реєстрацію за запрошенням',
      topUpPromptPre: 'Поповніть рахунок мінімум на',
      topUpPromptMid: 'одним платежем протягом',
      topUpPromptSuffix: 'днів після реєстрації — і ви, і друг, який вас запросив, отримаєте по',
      topUpPromptEnd: 'на баланс.',
      currency: 'грн',
      dayOne: 'день',
      dayFew: 'дні',
      dayMany: 'днів',
      timeLeft: 'Залишилось {{days}} {{unit}} (до {{date}})',
      lastDay: 'Сьогодні останній день',
      hide: 'Сховати',
    },
    firstLesson: {
      welcome: 'Вітаємо на Lingvish!',
      subtitle: 'Запишіться на ваш перший урок англійської та розпочніть навчання вже сьогодні',
      benefit1: 'Індивідуально або в групі',
      benefit2: 'Гнучкий графік',
      benefit3: 'Досвідчені викладачі',
      cta: 'Записатися на урок',
    },
    modal: {
      title: 'Заповніть профіль',
      stepOf: 'Крок {{current}} з {{total}}',
      back: 'Назад',
      next: 'Далі',
      saving: 'Збереження...',
    },
    errors: {
      missingUserId: 'Помилка: відсутній ID користувача',
      nicknameCheck: 'Помилка перевірки',
      nicknameTaken: 'Цей нікнейм вже зайнятий',
      invalidPhone: 'Введіть коректний номер телефону',
      saveFailed: 'Помилка збереження',
      saveDataFailed: 'Помилка збереження даних',
    },
    nickname: {
      stepTitle: 'Нікнейм',
      heading: 'Оберіть нікнейм',
      subheading: "Це ім'я бачитимуть інші",
      label: 'Нікнейм',
      placeholder: 'your_nickname',
      hint: 'Латинські літери, цифри та _',
      checking: 'Перевірка...',
      available: 'Доступний',
    },
    phone: {
      stepTitle: 'Телефон',
      heading: 'Номер телефону',
      optional: "(необов'язково)",
      subheading: "Для зв'язку та консультацій",
      label: 'Телефон',
      placeholder: '+380XXXXXXXXX',
      hint: 'Формат: +380XXXXXXXXX або 0XXXXXXXXX',
      valid: 'Коректний',
    },
    birthdate: {
      stepTitle: 'Дата народження',
      heading: 'Дата народження',
      subheading: 'Для персоналізації навчання',
      day: 'День',
      month: 'Місяць',
      year: 'Рік',
      months: {
        m01: 'Січень',
        m02: 'Лютий',
        m03: 'Березень',
        m04: 'Квітень',
        m05: 'Травень',
        m06: 'Червень',
        m07: 'Липень',
        m08: 'Серпень',
        m09: 'Вересень',
        m10: 'Жовтень',
        m11: 'Листопад',
        m12: 'Грудень',
      },
    },
    gender: {
      stepTitle: 'Стать',
      heading: 'Оберіть стать',
      subheading: 'Для персоналізації контенту',
      male: 'Чоловіча',
      female: 'Жіноча',
      other: 'Інша',
      preferNotToSay: 'Не хочу вказувати',
    },
    experience: {
      stepTitle: 'Досвід',
      heading: 'Досвід вивчення англійської',
      subheading: 'Чи вивчали ви англійську раніше?',
      never: 'Ні, ніколи не вчив(ла)',
      neverDesc: 'Починаю з нуля',
      some: 'Так, вчив(ла) раніше',
      someDesc: 'Маю певний досвід',
      neverNote: 'Чудово! Ми підберемо для вас курс для початківців з нуля.',
    },
    selfAssessment: {
      heading: 'Оцініть свій рівень',
      subheading: 'Як би ви оцінили свою англійську?',
      note: 'За бажанням Ви зможете пройти тест для точнішого визначення рівня на наступному кроці, або пізніше в особистому кабінеті.',
      starter: 'Нульовий',
      starterDesc: 'Знаю лише кілька слів',
      a1: 'Початковий (A1)',
      a1Desc: 'Розумію прості фрази',
      a2: 'Базовий (A2)',
      a2Desc: 'Можу спілкуватися на прості теми',
      b1: 'Середній (B1)',
      b1Desc: 'Розумію основний зміст текстів',
      b2: 'Вище середнього (B2)',
      b2Desc: 'Вільно спілкуюсь на різні теми',
      c1: 'Просунутий (C1)',
      c1Desc: 'Майже вільно володію мовою',
    },
    levelTest: {
      stepTitle: 'Тест на рівень',
      heading: 'Тест на рівень англійської',
      selfLabel: 'Ваша самооцінка',
      subheading: 'Пройдіть тест для точнішого визначення рівня та підбору оптимальної програми',
      takeNow: 'Пройти тест зараз',
      useSelfAssessed: 'Використати самооцінку ({{level}})',
      skipForNow: 'Пройти пізніше',
      loading: 'Завантаження...',
    },
    page: {
      genderOptions: {
        male: 'Чоловіча',
        female: 'Жіноча',
        other: 'Інша',
        preferNotToSay: 'Не хочу вказувати',
      },
      dialects: {
        british: 'Британська',
        american: 'Американська',
        both: 'Обидві',
        britishDesc: 'British English',
        americanDesc: 'American English',
        bothDesc: 'British & American',
      },
      englishDialectStepTitle: 'Тип англійської',
      dialectHeading: 'Яку англійську вивчати?',
      dialectSubheading: 'Оберіть бажаний варіант англійської',
      loading: 'Завантаження...',
    },
    teacherAuthModal: {
      loginTitle: 'Вхід для вчителя',
      registerTitle: 'Реєстрація вчителя',
      loginEmailLabel: 'Email або нікнейм',
      passwordLabel: 'Пароль',
      passwordPlaceholder: 'Введіть пароль',
      forgot: 'Забули пароль?',
      loggingIn: 'Вхід...',
      login: 'Увійти',
      noAccount: 'Ще не маєте акаунту?',
      createOne: 'Створити',
      step1Intro: 'Введіть ваші дані та код, отриманий від адміністратора',
      firstNameLabel: "Ім'я *",
      firstNamePlaceholder: 'Іван',
      lastNameLabel: 'Прізвище *',
      lastNamePlaceholder: 'Петренко',
      emailInvalid: 'Введіть коректний email',
      codeLabel: 'Код реєстрації *',
      verifying: 'Перевірка...',
      verifyCode: 'Перевірити код',
      haveAccount: 'Вже маєте акаунт?',
      loginLink: 'Увійти',
      step2Greeting: 'Вітаємо, {{name}}! Створіть нікнейм та пароль для входу',
      nicknameLabel: 'Нікнейм *',
      nicknameInvalid: 'Використовуйте лише латинські літери, цифри та _',
      nicknameShort: 'Нікнейм має містити мінімум 3 символи',
      nicknameHint: 'Тільки латинські літери, цифри та _',
      phoneLabel: 'Телефон',
      phoneInvalid: 'Введіть коректний номер телефону',
      passwordLabelReq: 'Пароль *',
      passwordPlaceholderMin: 'Мінімум 8 символів',
      strengthChars: '8+ символів',
      strengthUpper: 'Велика літера',
      strengthLower: 'Мала літера',
      strengthDigit: 'Цифра',
      confirmPasswordLabel: 'Підтвердження паролю *',
      confirmPasswordPlaceholder: 'Повторіть пароль',
      passwordsDontMatch: 'Паролі не співпадають',
      consentPrefix: 'Я погоджуюсь з ',
      privacyPolicy: 'політикою конфіденційності',
      consentSuffix: ' та обробкою моїх персональних даних',
      registering: 'Реєстрація...',
      completeRegistration: 'Завершити реєстрацію',
      backToCode: 'Назад до введення коду',
      forgotTitle: 'Відновлення паролю',
      forgotEmailIntro: "Введіть email, пов'язаний з вашим акаунтом",
      sending: 'Відправлення...',
      sendCode: 'Надіслати код',
      enterCodeFrom: 'Введіть код з листа на {{email}}',
      recoveryCodeLabel: 'Код відновлення',
      checking: 'Перевірка...',
      confirm: 'Підтвердити',
      back: 'Назад',
      newPasswordTitle: 'Створіть новий пароль',
      newPasswordLabel: 'Новий пароль',
      confirmLabel: 'Підтвердження',
      changing: 'Зміна...',
      changePassword: 'Змінити пароль',
      errNotTeacher: 'Цей акаунт не є акаунтом вчителя',
      errLoginFailed: 'Помилка входу',
      errConnection: "Помилка з'єднання. Спробуйте пізніше.",
      errEnterEmail: 'Введіть email',
      errSendCodeFailed: 'Помилка відправлення коду',
      errEnterCode: 'Введіть код',
      errInvalidCode: 'Невірний код',
      errWeakPassword: 'Пароль не відповідає вимогам безпеки',
      errPasswordsDontMatch: 'Паролі не співпадають',
      errChangePasswordFailed: 'Помилка зміни паролю',
      errCodeInvalid: 'Код недійсний',
      errCodeCheckFailed: 'Помилка перевірки коду. Спробуйте пізніше.',
      errRegisterFailed: 'Помилка реєстрації',
      errRegisterConnection: 'Помилка реєстрації. Спробуйте пізніше.',
    },
    teacherAuth: {
      backToLogin: 'Назад до входу',
      backHome: 'На головну',
      permissionLabels: {
        users: 'Користувачі',
        finance: 'Фінанси',
        schedule: 'Розклад',
        programs: 'Програми',
        products: 'Товари',
        reviews: 'Відгуки',
        settings: 'Налаштування',
        clubs: 'Клуби',
        presentations: 'Презентації',
        homework: 'Домашні завдання',
        lessons: 'Уроки',
        courses: 'Курси',
        offers: 'Пропозиції',
        specialLessons: 'Спеціальні уроки',
        overview: 'Огляд',
      },
      forgot: {
        title: 'Відновлення паролю',
        subtitle: 'Оберіть спосіб відновлення паролю',
        emailTab: 'Email',
        phoneTab: 'Телефон',
        emailLabel: 'Email',
        emailPlaceholder: 'teacher@example.com',
        phoneLabel: 'Номер телефону',
        phonePlaceholder: '+380 XX XXX XX XX',
        submit: 'Надіслати інструкції',
        successTitle: 'Успішно',
        successMessage: 'Інструкції для відновлення паролю надіслано!',
      },
      titles: {
        loginStaff: 'Вхід для співробітників',
        register: 'Реєстрація',
        registerAdmin: 'Реєстрація адміністратора',
        registerTeacher: 'Реєстрація вчителя',
      },
      login: {
        emailOrNicknameLabel: 'Email або нікнейм',
        emailPlaceholder: 'teacher@example.com',
        passwordLabel: 'Пароль',
        passwordPlaceholder: 'Введіть пароль',
        forgot: 'Забули пароль?',
        submit: 'Увійти',
        submitting: 'Вхід...',
        switchToRegister: 'Ще не маєте акаунту? Створити',
        notTeacherAccount: 'Цей акаунт не є акаунтом вчителя або адміністратора',
        loginError: 'Помилка входу',
        connectionError: "Помилка з'єднання. Спробуйте пізніше.",
      },
      step1: {
        intro: 'Введіть ваші дані та код, отриманий від адміністратора',
        lastNameLabel: 'Прізвище *',
        lastNamePlaceholder: 'Петренко',
        firstNameLabel: "Ім'я *",
        firstNamePlaceholder: 'Іван',
        emailLabel: 'Email *',
        emailPlaceholder: 'teacher@example.com',
        emailInvalid: 'Введіть коректний email',
        codeLabel: 'Код реєстрації *',
        codePlaceholder: 'XXXXXXXX',
        submit: 'Перевірити код',
        submitting: 'Перевірка...',
        switchToLogin: 'Вже маєте акаунт? Увійти',
        codeInvalid: 'Код недійсний',
        codeCheckError: 'Помилка перевірки коду. Спробуйте пізніше.',
      },
      step2: {
        greeting: 'Вітаємо, {{name}}! Створіть нікнейм та пароль для входу',
        permissionsTitle: 'Ваші дозволи:',
        nicknameLabel: 'Нікнейм *',
        nicknamePlaceholder: 'your_nickname',
        nicknameInvalid: 'Використовуйте лише латинські літери, цифри та _',
        nicknameShort: 'Нікнейм має містити мінімум 3 символи',
        nicknameHint: 'Тільки латинські літери, цифри та _',
        phoneLabel: 'Телефон',
        phonePlaceholder: '+380 67 123 4567',
        phoneInvalid: 'Введіть коректний номер телефону',
        passwordLabel: 'Пароль *',
        passwordPlaceholder: 'Мінімум 8 символів',
        confirmPasswordLabel: 'Підтвердження паролю *',
        confirmPasswordPlaceholder: 'Повторіть пароль',
        passwordsDontMatch: 'Паролі не співпадають',
        consent: 'Я погоджуюсь із використанням та обробкою моїх персональних даних',
        submit: 'Завершити реєстрацію',
        submitting: 'Реєстрація...',
        backToCode: 'Назад до введення коду',
        registerError: 'Помилка реєстрації',
        registerConnectionError: 'Помилка реєстрації. Спробуйте пізніше.',
        strength: {
          lengthLabel: '8+ символів',
          uppercaseLabel: 'Велика літера',
          lowercaseLabel: 'Мала літера',
          numberLabel: 'Цифра',
        },
      },
    },
    teacherVerification: {
      backHome: 'На головну',
      back: 'Назад',
      titleStep1: 'Реєстрація вчителя',
      titleStep2: 'Завершення реєстрації',
      subtitleStep1: 'Введіть ваші дані та код, отриманий від адміністратора',
      subtitleStep2: 'Вітаємо, {{name}}! Створіть нікнейм та пароль для входу',
      firstName: "Ім'я *",
      firstNamePh: 'Іван',
      lastName: 'Прізвище *',
      lastNamePh: 'Петренко',
      email: 'Email *',
      emailInvalid: 'Введіть коректний email',
      code: 'Код реєстрації *',
      checking: 'Перевірка...',
      validateCode: 'Перевірити код',
      haveAccount: 'Вже маєте акаунт?',
      login: 'Увійти',
      yourName: "Ваше ім'я:",
      nickname: 'Нікнейм *',
      nicknamePh: 'your_nickname',
      nicknameLatinOnly: 'Використовуйте лише латинські літери, цифри та _',
      nicknameMinLen: 'Нікнейм має містити мінімум 3 символи',
      nicknameHint: 'Тільки латинські літери, цифри та _',
      phone: 'Телефон',
      phonePh: '+380 67 123 4567',
      password: 'Пароль *',
      passwordPh: 'Мінімум 8 символів',
      passwordShort: 'Пароль має містити мінімум 8 символів',
      passwordConfirm: 'Підтвердження паролю *',
      passwordConfirmPh: 'Повторіть пароль',
      passwordsDontMatch: 'Паролі не співпадають',
      consent: 'Я погоджуюсь із використанням та обробкою моїх персональних даних',
      registering: 'Реєстрація...',
      complete: 'Завершити реєстрацію',
      invalidCode: 'Код недійсний',
      codeCheckError: 'Помилка перевірки коду. Спробуйте пізніше.',
      registerError: 'Помилка реєстрації',
      registerRetryError: 'Помилка реєстрації. Спробуйте пізніше.',
    },
    studentAuth: {
      passwordStrength: {
        minLength: 'Мінімум 8 символів',
      },
      alerts: {
        successTitle: 'Успішно',
        codeSent: 'Код відновлення надіслано на пошту',
        passwordChanged: 'Пароль успішно змінено! Тепер ви можете увійти з новим паролем.',
        emailVerified: 'Email підтверджено! Ласкаво просимо до LINGVISH SPACE!',
        newCodeSent: 'Новий код надіслано на вашу пошту',
      },
      errors: {
        enterEmail: 'Введіть email',
        sendCodeFailed: 'Помилка відправлення коду',
        connection: "Помилка з'єднання. Спробуйте пізніше.",
        enterCode: 'Введіть код',
        invalidCode: 'Невірний код',
        enter6DigitCode: 'Введіть 6-значний код',
        passwordRequirements: 'Пароль має містити мінімум 8 символів',
        passwordsMismatch: 'Паролі не співпадають',
        passwordChangeFailed: 'Помилка зміни паролю',
        fillAllFields: 'Будь ласка, заповніть всі поля',
        acceptTerms: 'Необхідно погодитись із використанням та обробкою персональних даних',
        passwordFormat: 'Пароль має містити мінімум 8 символів',
        registerFailed: 'Помилка реєстрації',
        fillChildFields: "Будь ласка, заповніть обов'язкові поля дитини",
        childAgeRange: 'Вік дитини має бути від 3 до 17 років',
        childNicknameShort: 'Нікнейм дитини має містити мінімум 3 символи',
        loadUserFailed: 'Не вдалося завантажити дані користувача. Спробуйте ще раз.',
        teacherAccount: 'Цей акаунт є акаунтом вчителя. Використовуйте вхід для вчителів.',
      },
      verify: {
        heading: 'Підтвердіть ваш email',
        sentTo: 'Ми надіслали код підтвердження на',
        codeLabel: 'Код підтвердження',
        submitting: 'Перевірка...',
        submit: 'Підтвердити',
        resend: 'Надіслати код ще раз',
        checkSpam: 'Не отримали лист? Перевірте папку «Спам».',
      },
      forgot: {
        backToLogin: 'Назад до входу',
        title: 'Відновлення паролю',
        emailIntro: "Введіть email, пов'язаний з вашим акаунтом",
        sending: 'Відправлення...',
        sendCode: 'Надіслати код',
        codeSentIntro: 'Введіть код, який ми надіслали на {{email}}',
        codeLabel: 'Код відновлення',
        verifying: 'Перевірка...',
        verifyCode: 'Підтвердити код',
        tryAgain: 'Не отримали код? Спробувати ще раз',
        newPasswordIntro: 'Створіть новий пароль для вашого акаунту',
        newPasswordLabel: 'Новий пароль',
        newPasswordPlaceholder: 'Мінімум 8 символів',
        confirmPasswordLabel: 'Підтвердження паролю',
        confirmPasswordPlaceholder: 'Повторіть новий пароль',
        passwordsMismatch: 'Паролі не співпадають',
        changing: 'Зміна паролю...',
        changePassword: 'Змінити пароль',
      },
      login: {
        backHome: 'На головну',
        title: 'Вхід',
        emailOrNicknameLabel: 'Email або нікнейм',
        emailOrNicknamePlaceholder: 'ivan.koval@example.com або sofia_kid',
        passwordLabel: 'Пароль',
        forgot: 'Забули пароль?',
        submitting: 'Вхід...',
        submit: 'Увійти',
        or: 'або',
        noAccount: 'Немає акаунту? Зареєструватись',
      },
      registerRole: {
        backHome: 'На головну',
        title: 'Реєстрація',
        subtitle: 'Хто буде навчатися?',
        invitedBy: 'Вас запросив(ла)',
        bonusPrefix: 'Зареєструйтеся і поповніть рахунок на суму від',
        bonusAmount: '500 грн',
        bonusWithin: 'протягом',
        bonusDays: '30 днів',
        bonusAfter: 'після реєстрації — і ви отримаєте',
        bonusReward: '50 грн',
        bonusEnd: 'бонусу. Ваш друг також отримає 50 грн.',
        me: 'Я',
        meDesc: 'Буду навчатися самостійно',
        myChild: 'Моя дитина',
        myChildDesc: 'Реєструю дитину для навчання',
        haveAccount: 'Вже є акаунт? Увійти',
      },
      registerAge: {
        back: 'Назад',
        title: 'Реєстрація',
        subtitle: 'Скільки вам років?',
        under14: 'Менше 14 років',
        age14to18: '14-18 років',
        age18plus: '18+ років',
      },
      registerTeen: {
        back: 'Назад',
        title: 'Реєстрація',
        surnameLabel: 'Прізвище',
        surnamePlaceholder: 'Коваль',
        firstNameLabel: "Ім'я",
        firstNamePlaceholder: 'Іван',
        passwordLabel: 'Пароль',
        confirmPasswordLabel: 'Підтвердження паролю',
        consent: 'Я погоджуюсь із використанням та обробкою моїх персональних даних',
        submitting: 'Реєстрація...',
        submit: 'Зареєструватись',
        or: 'або',
      },
      registerAdult: {
        back: 'Назад',
        title: 'Реєстрація',
        nameLabel: "Ваше ім'я",
        namePlaceholder: 'Олена Коваль',
        passwordLabel: 'Пароль',
        confirmPasswordLabel: 'Підтвердження паролю',
        consent: 'Я погоджуюсь із використанням та обробкою персональних даних',
        next: 'Далі',
      },
      registerChild: {
        back: 'Назад',
        title: 'Реєстрація',
        subtitle: 'Дані дитини',
        childNameLabel: "Ім'я дитини",
        childNamePlaceholder: 'Софія',
        childAgeLabel: 'Вік дитини',
        childNicknameLabel: 'Нікнейм дитини',
        childNicknameHint: 'Дитина зможе входити за цим нікнеймом',
        childPasswordLabel: 'Пароль дитини',
        childPasswordPlaceholder: 'наприклад, kotik7',
        childPasswordHint: ". Простий пароль, який дитина запам'ятає.",
        childEmailLabel: 'Email дитини',
        childEmailHint: 'Потрібен для входу дитини через Google і відновлення паролю',
        submitting: 'Реєстрація...',
        submit: 'Завершити реєстрацію',
      },
    },
  },
  en: {
    adminAuth: {
      title: 'Administrator login',
      notAdminAccount: 'This account is not an administrator account',
      loginError: 'Login error',
      connectionError: 'Connection error. Please try again later.',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter password',
      loggingIn: 'Logging in...',
      loginBtn: 'Log in',
    },
    googleAuth: {
      cannotConnect: 'Could not connect to the server. Please try again later.',
      serverUnavailable: 'Server unavailable ({{status}}). Please try again later.',
      googleError: 'Google authorisation error',
      googleConnectError: 'Google connection error',
      loading: 'Loading...',
      loginWithGoogle: 'Sign in with Google',
    },
    referralBonus: {
      bonusIntro: 'Get a {{amount}} UAH bonus for signing up via invite',
      topUpPromptPre: 'Top up your balance with at least',
      topUpPromptMid: 'in one payment within',
      topUpPromptSuffix: 'days of signing up — and both you and your inviter get',
      topUpPromptEnd: 'on the balance.',
      currency: 'UAH',
      dayOne: 'day',
      dayFew: 'days',
      dayMany: 'days',
      timeLeft: '{{days}} {{unit}} left (until {{date}})',
      lastDay: 'Today is the last day',
      hide: 'Hide',
    },
    firstLesson: {
      welcome: 'Welcome to Lingvish!',
      subtitle: 'Book your first English lesson and start learning today',
      benefit1: 'Individual or group lessons',
      benefit2: 'Flexible schedule',
      benefit3: 'Experienced teachers',
      cta: 'Book a lesson',
    },
    modal: {
      title: 'Complete your profile',
      stepOf: 'Step {{current}} of {{total}}',
      back: 'Back',
      next: 'Next',
      saving: 'Saving...',
    },
    errors: {
      missingUserId: 'Error: user ID is missing',
      nicknameCheck: 'Check failed',
      nicknameTaken: 'This nickname is already taken',
      invalidPhone: 'Enter a valid phone number',
      saveFailed: 'Save failed',
      saveDataFailed: 'Failed to save data',
    },
    nickname: {
      stepTitle: 'Nickname',
      heading: 'Choose a nickname',
      subheading: 'This is the name others will see',
      label: 'Nickname',
      placeholder: 'your_nickname',
      hint: 'Latin letters, digits and _',
      checking: 'Checking...',
      available: 'Available',
    },
    phone: {
      stepTitle: 'Phone',
      heading: 'Phone number',
      optional: '(optional)',
      subheading: 'For contact and consultations',
      label: 'Phone',
      placeholder: '+380XXXXXXXXX',
      hint: 'Format: +380XXXXXXXXX or 0XXXXXXXXX',
      valid: 'Valid',
    },
    birthdate: {
      stepTitle: 'Date of birth',
      heading: 'Date of birth',
      subheading: 'To personalize your learning',
      day: 'Day',
      month: 'Month',
      year: 'Year',
      months: {
        m01: 'January',
        m02: 'February',
        m03: 'March',
        m04: 'April',
        m05: 'May',
        m06: 'June',
        m07: 'July',
        m08: 'August',
        m09: 'September',
        m10: 'October',
        m11: 'November',
        m12: 'December',
      },
    },
    gender: {
      stepTitle: 'Gender',
      heading: 'Choose your gender',
      subheading: 'To personalize your content',
      male: 'Male',
      female: 'Female',
      other: 'Other',
      preferNotToSay: 'Prefer not to say',
    },
    experience: {
      stepTitle: 'Experience',
      heading: 'English learning experience',
      subheading: 'Have you studied English before?',
      never: "No, I've never studied it",
      neverDesc: 'Starting from scratch',
      some: "Yes, I've studied it before",
      someDesc: 'I have some experience',
      neverNote: "Great! We'll pick a beginner course for you.",
    },
    selfAssessment: {
      heading: 'Rate your level',
      subheading: 'How would you rate your English?',
      note: "If you'd like, you can take the test for a more precise level on the next step, or later in your account.",
      starter: 'Zero',
      starterDesc: 'I only know a few words',
      a1: 'Beginner (A1)',
      a1Desc: 'I understand simple phrases',
      a2: 'Elementary (A2)',
      a2Desc: 'I can talk about simple topics',
      b1: 'Intermediate (B1)',
      b1Desc: 'I understand the main idea of texts',
      b2: 'Upper-intermediate (B2)',
      b2Desc: 'I speak fluently on various topics',
      c1: 'Advanced (C1)',
      c1Desc: 'I speak the language almost fluently',
    },
    levelTest: {
      stepTitle: 'Level test',
      heading: 'English level test',
      selfLabel: 'Your self-assessment',
      subheading: 'Take the test for a more precise level and the best-fit program',
      takeNow: 'Take the test now',
      useSelfAssessed: 'Use my self-assessment ({{level}})',
      skipForNow: 'Take it later',
      loading: 'Loading...',
    },
    page: {
      genderOptions: {
        male: 'Male',
        female: 'Female',
        other: 'Other',
        preferNotToSay: 'Prefer not to say',
      },
      dialects: {
        british: 'British',
        american: 'American',
        both: 'Both',
        britishDesc: 'British English',
        americanDesc: 'American English',
        bothDesc: 'British & American',
      },
      englishDialectStepTitle: 'English type',
      dialectHeading: 'Which English do you want to learn?',
      dialectSubheading: 'Choose your preferred English variant',
      loading: 'Loading...',
    },
    teacherAuthModal: {
      loginTitle: 'Teacher login',
      registerTitle: 'Teacher sign up',
      loginEmailLabel: 'Email or nickname',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter your password',
      forgot: 'Forgot your password?',
      loggingIn: 'Logging in...',
      login: 'Log in',
      noAccount: "Don't have an account?",
      createOne: 'Create one',
      step1Intro: 'Enter your details and the code you received from the administrator',
      firstNameLabel: 'First name *',
      firstNamePlaceholder: 'John',
      lastNameLabel: 'Surname *',
      lastNamePlaceholder: 'Smith',
      emailInvalid: 'Enter a valid email',
      codeLabel: 'Registration code *',
      verifying: 'Verifying...',
      verifyCode: 'Verify code',
      haveAccount: 'Already have an account?',
      loginLink: 'Log in',
      step2Greeting: 'Welcome, {{name}}! Create a nickname and password to log in',
      nicknameLabel: 'Nickname *',
      nicknameInvalid: 'Use only Latin letters, digits and _',
      nicknameShort: 'Nickname must be at least 3 characters',
      nicknameHint: 'Only Latin letters, digits and _',
      phoneLabel: 'Phone',
      phoneInvalid: 'Enter a valid phone number',
      passwordLabelReq: 'Password *',
      passwordPlaceholderMin: 'At least 8 characters',
      strengthChars: '8+ characters',
      strengthUpper: 'Uppercase letter',
      strengthLower: 'Lowercase letter',
      strengthDigit: 'Digit',
      confirmPasswordLabel: 'Confirm password *',
      confirmPasswordPlaceholder: 'Repeat password',
      passwordsDontMatch: "Passwords don't match",
      consentPrefix: 'I agree to the ',
      privacyPolicy: 'privacy policy',
      consentSuffix: ' and processing of my personal data',
      registering: 'Signing up...',
      completeRegistration: 'Complete registration',
      backToCode: 'Back to code entry',
      forgotTitle: 'Password recovery',
      forgotEmailIntro: 'Enter the email linked to your account',
      sending: 'Sending...',
      sendCode: 'Send code',
      enterCodeFrom: 'Enter the code from the email at {{email}}',
      recoveryCodeLabel: 'Recovery code',
      checking: 'Checking...',
      confirm: 'Confirm',
      back: 'Back',
      newPasswordTitle: 'Create a new password',
      newPasswordLabel: 'New password',
      confirmLabel: 'Confirmation',
      changing: 'Changing...',
      changePassword: 'Change password',
      errNotTeacher: 'This account is not a teacher account',
      errLoginFailed: 'Login failed',
      errConnection: 'Connection error. Please try again later.',
      errEnterEmail: 'Enter email',
      errSendCodeFailed: 'Failed to send code',
      errEnterCode: 'Enter code',
      errInvalidCode: 'Invalid code',
      errWeakPassword: 'Password does not meet security requirements',
      errPasswordsDontMatch: "Passwords don't match",
      errChangePasswordFailed: 'Failed to change password',
      errCodeInvalid: 'Invalid code',
      errCodeCheckFailed: 'Code verification failed. Please try again later.',
      errRegisterFailed: 'Registration failed',
      errRegisterConnection: 'Registration failed. Please try again later.',
    },
    teacherAuth: {
      backToLogin: 'Back to login',
      backHome: 'Back to home',
      permissionLabels: {
        users: 'Users',
        finance: 'Finance',
        schedule: 'Schedule',
        programs: 'Programs',
        products: 'Products',
        reviews: 'Reviews',
        settings: 'Settings',
        clubs: 'Clubs',
        presentations: 'Presentations',
        homework: 'Homework',
        lessons: 'Lessons',
        courses: 'Courses',
        offers: 'Offers',
        specialLessons: 'Special lessons',
        overview: 'Overview',
      },
      forgot: {
        title: 'Password recovery',
        subtitle: 'Choose a password recovery method',
        emailTab: 'Email',
        phoneTab: 'Phone',
        emailLabel: 'Email',
        emailPlaceholder: 'teacher@example.com',
        phoneLabel: 'Phone number',
        phonePlaceholder: '+380 XX XXX XX XX',
        submit: 'Send instructions',
        successTitle: 'Success',
        successMessage: 'Password recovery instructions sent!',
      },
      titles: {
        loginStaff: 'Staff login',
        register: 'Sign up',
        registerAdmin: 'Admin sign up',
        registerTeacher: 'Teacher sign up',
      },
      login: {
        emailOrNicknameLabel: 'Email or nickname',
        emailPlaceholder: 'teacher@example.com',
        passwordLabel: 'Password',
        passwordPlaceholder: 'Enter your password',
        forgot: 'Forgot your password?',
        submit: 'Log in',
        submitting: 'Logging in...',
        switchToRegister: "Don't have an account? Create one",
        notTeacherAccount: 'This account is not a teacher or admin account',
        loginError: 'Login failed',
        connectionError: 'Connection error. Please try again later.',
      },
      step1: {
        intro: 'Enter your details and the code you received from the administrator',
        lastNameLabel: 'Surname *',
        lastNamePlaceholder: 'Smith',
        firstNameLabel: 'First name *',
        firstNamePlaceholder: 'John',
        emailLabel: 'Email *',
        emailPlaceholder: 'teacher@example.com',
        emailInvalid: 'Enter a valid email',
        codeLabel: 'Registration code *',
        codePlaceholder: 'XXXXXXXX',
        submit: 'Verify code',
        submitting: 'Verifying...',
        switchToLogin: 'Already have an account? Log in',
        codeInvalid: 'Invalid code',
        codeCheckError: 'Code verification failed. Please try again later.',
      },
      step2: {
        greeting: 'Welcome, {{name}}! Create a nickname and password to log in',
        permissionsTitle: 'Your permissions:',
        nicknameLabel: 'Nickname *',
        nicknamePlaceholder: 'your_nickname',
        nicknameInvalid: 'Use only Latin letters, digits and _',
        nicknameShort: 'Nickname must be at least 3 characters',
        nicknameHint: 'Only Latin letters, digits and _',
        phoneLabel: 'Phone',
        phonePlaceholder: '+380 67 123 4567',
        phoneInvalid: 'Enter a valid phone number',
        passwordLabel: 'Password *',
        passwordPlaceholder: 'At least 8 characters',
        confirmPasswordLabel: 'Confirm password *',
        confirmPasswordPlaceholder: 'Repeat password',
        passwordsDontMatch: "Passwords don't match",
        consent: 'I agree to the use and processing of my personal data',
        submit: 'Complete registration',
        submitting: 'Signing up...',
        backToCode: 'Back to code entry',
        registerError: 'Registration failed',
        registerConnectionError: 'Registration failed. Please try again later.',
        strength: {
          lengthLabel: '8+ characters',
          uppercaseLabel: 'Uppercase letter',
          lowercaseLabel: 'Lowercase letter',
          numberLabel: 'Digit',
        },
      },
    },
    teacherVerification: {
      backHome: 'Back to home',
      back: 'Back',
      titleStep1: 'Teacher registration',
      titleStep2: 'Finish registration',
      subtitleStep1: 'Enter your details and the code you received from the administrator',
      subtitleStep2: 'Welcome, {{name}}! Choose a nickname and password to sign in',
      firstName: 'First name *',
      firstNamePh: 'John',
      lastName: 'Last name *',
      lastNamePh: 'Smith',
      email: 'Email *',
      emailInvalid: 'Enter a valid email',
      code: 'Registration code *',
      checking: 'Checking...',
      validateCode: 'Verify code',
      haveAccount: 'Already have an account?',
      login: 'Sign in',
      yourName: 'Your name:',
      nickname: 'Nickname *',
      nicknamePh: 'your_nickname',
      nicknameLatinOnly: 'Use only Latin letters, digits and _',
      nicknameMinLen: 'Nickname must be at least 3 characters',
      nicknameHint: 'Latin letters, digits and _ only',
      phone: 'Phone',
      phonePh: '+380 67 123 4567',
      password: 'Password *',
      passwordPh: 'At least 8 characters',
      passwordShort: 'Password must be at least 8 characters',
      passwordConfirm: 'Confirm password *',
      passwordConfirmPh: 'Repeat password',
      passwordsDontMatch: "Passwords don't match",
      consent: 'I agree to the use and processing of my personal data',
      registering: 'Signing up...',
      complete: 'Complete registration',
      invalidCode: 'Invalid code',
      codeCheckError: 'Failed to verify code. Please try again later.',
      registerError: 'Registration failed',
      registerRetryError: 'Registration failed. Please try again later.',
    },
    studentAuth: {
      passwordStrength: {
        minLength: 'At least 8 characters',
      },
      alerts: {
        successTitle: 'Success',
        codeSent: 'Recovery code sent to your email',
        passwordChanged: 'Password changed successfully! You can now log in with your new password.',
        emailVerified: 'Email verified! Welcome to LINGVISH SPACE!',
        newCodeSent: 'A new code has been sent to your email',
      },
      errors: {
        enterEmail: 'Enter your email',
        sendCodeFailed: 'Failed to send code',
        connection: 'Connection error. Please try again later.',
        enterCode: 'Enter the code',
        invalidCode: 'Invalid code',
        enter6DigitCode: 'Enter the 6-digit code',
        passwordRequirements: 'Password must be at least 8 characters',
        passwordsMismatch: "Passwords don't match",
        passwordChangeFailed: 'Failed to change password',
        fillAllFields: 'Please fill in all fields',
        acceptTerms: 'You must agree to the use and processing of personal data',
        passwordFormat: 'Password must be at least 8 characters',
        registerFailed: 'Registration failed',
        fillChildFields: "Please fill in the child's required fields",
        childAgeRange: "Child's age must be between 3 and 17",
        childNicknameShort: "Child's nickname must be at least 3 characters",
        loadUserFailed: 'Failed to load user data. Please try again.',
        teacherAccount: 'This is a teacher account. Use the teacher login.',
      },
      verify: {
        heading: 'Verify your email',
        sentTo: 'We sent a verification code to',
        codeLabel: 'Verification code',
        submitting: 'Verifying...',
        submit: 'Confirm',
        resend: 'Resend code',
        checkSpam: 'Did not get the email? Check the "Spam" folder.',
      },
      forgot: {
        backToLogin: 'Back to login',
        title: 'Password recovery',
        emailIntro: 'Enter the email linked to your account',
        sending: 'Sending...',
        sendCode: 'Send code',
        codeSentIntro: 'Enter the code we sent to {{email}}',
        codeLabel: 'Recovery code',
        verifying: 'Verifying...',
        verifyCode: 'Confirm code',
        tryAgain: "Didn't get the code? Try again",
        newPasswordIntro: 'Create a new password for your account',
        newPasswordLabel: 'New password',
        newPasswordPlaceholder: 'At least 8 characters',
        confirmPasswordLabel: 'Confirm password',
        confirmPasswordPlaceholder: 'Repeat the new password',
        passwordsMismatch: "Passwords don't match",
        changing: 'Changing password...',
        changePassword: 'Change password',
      },
      login: {
        backHome: 'Back to home',
        title: 'Log in',
        emailOrNicknameLabel: 'Email or nickname',
        emailOrNicknamePlaceholder: 'ivan.koval@example.com or sofia_kid',
        passwordLabel: 'Password',
        forgot: 'Forgot your password?',
        submitting: 'Logging in...',
        submit: 'Log in',
        or: 'or',
        noAccount: "Don't have an account? Sign up",
      },
      registerRole: {
        backHome: 'Back to home',
        title: 'Sign up',
        subtitle: 'Who will be learning?',
        invitedBy: 'You were invited by',
        bonusPrefix: 'Sign up and top up your balance with at least',
        bonusAmount: '500 UAH',
        bonusWithin: 'within',
        bonusDays: '30 days',
        bonusAfter: 'of signing up — and you get',
        bonusReward: '50 UAH',
        bonusEnd: 'as a bonus. Your friend also gets 50 UAH.',
        me: 'Me',
        meDesc: 'I will learn on my own',
        myChild: 'My child',
        myChildDesc: 'Signing my child up to learn',
        haveAccount: 'Already have an account? Log in',
      },
      registerAge: {
        back: 'Back',
        title: 'Sign up',
        subtitle: 'How old are you?',
        under14: 'Under 14',
        age14to18: '14-18',
        age18plus: '18+',
      },
      registerTeen: {
        back: 'Back',
        title: 'Sign up',
        surnameLabel: 'Surname',
        surnamePlaceholder: 'Smith',
        firstNameLabel: 'First name',
        firstNamePlaceholder: 'John',
        passwordLabel: 'Password',
        confirmPasswordLabel: 'Confirm password',
        consent: 'I agree to the use and processing of my personal data',
        submitting: 'Signing up...',
        submit: 'Sign up',
        or: 'or',
      },
      registerAdult: {
        back: 'Back',
        title: 'Sign up',
        nameLabel: 'Your name',
        namePlaceholder: 'Olena Koval',
        passwordLabel: 'Password',
        confirmPasswordLabel: 'Confirm password',
        consent: 'I agree to the use and processing of personal data',
        next: 'Next',
      },
      registerChild: {
        back: 'Back',
        title: 'Sign up',
        subtitle: "Child's details",
        childNameLabel: "Child's name",
        childNamePlaceholder: 'Sofia',
        childAgeLabel: "Child's age",
        childNicknameLabel: "Child's nickname",
        childNicknameHint: 'Your child will log in with this nickname',
        childPasswordLabel: "Child's password",
        childPasswordPlaceholder: 'e.g., kotik7',
        childPasswordHint: '. A simple password your child will remember.',
        childEmailLabel: "Child's email",
        childEmailHint: 'Needed for Google login and password recovery',
        submitting: 'Signing up...',
        submit: 'Complete registration',
      },
    },
  },
};

export default dict;
